/** @format */

import React from 'react'

import { Image } from 'antd'
import { FilePdfTwoTone } from '@ant-design/icons'

export default function ModalRecipe(props) {
	if (/.pdf/.test(props.url)) {
		return (
			<a href={props.url} target='_blank' rel='noopener noreferrer'>
				<FilePdfTwoTone style={{ fontSize: '80px' }} twoToneColor='#F40F02' />
			</a>
		)
	}
	return <Image width={100} src={props.url} />
}
